module.exports = __webpack_public_path__ + "static/img/icon-woori.87c0a79f.png";